import sectwo from '../images/sectwo.svg'
import programmer from '../images/programmer.svg'

export const seguridad = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Prosperidad, tecnología y seguridad',
  headline: 'Confía en nosotros',
  description:
    'Cualquier dato que ingreses en nuestra plataforma será altamente blindado, tu data personal y sobre tus cultivos están blindados en nuestra plataforma y contamos con un grupo de expertos en ciberseguridad.',
  buttonLabel: '¡Registrate!',
  linkTo: 'form',
  imgStart: '',
  img: sectwo,
  alt: 'Environment'
};

export const comunidad = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Amado por la comunidad',
  headline: 'El software es atendido por la comunidad',
  description:
    "Sin importar el tipo de cultivo, la comunidad aporta semanalmente grandes cambios y variaciones d nustro software modular para hacer más amplio la cartera de plantas que el usuario podrá cultivar sin procuparse.",
  buttonLabel: 'Abrir Repositorio',
  linkTo: 'form',
  imgStart: 'start',
  img: programmer,
  alt: 'Programmer'
};